import React from "react";
import { useInView } from "react-intersection-observer";
import Reveal from "react-awesome-reveal";
import "./footer.css";

const Footer = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div ref={ref}>
      <Reveal effect="fade" when={inView} triggerOnce={true}>
        <footer className="footer">
          <div className="footer__container container">
            <h1 className="footer__title">Andrew Hsu</h1>
            <ul className="footer__list">
              <li>
                <a href="#skills" className="footer__link">
                  Skills
                </a>
              </li>
              <li>
                <a href="#qualifications" className="footer__link">
                  Experience
                </a>
              </li>
              <li>
                <a href="#portfolio" className="footer__link">
                  Projects
                </a>
              </li>
            </ul>
            <div className="footer__social">
              {/* <a
                href="https://www.instagram.com/"
                className="footer__social-link"
                target="_blank"
              >
                <i class="bx bxl-facebook"></i>
              </a>
              <a
                href="https://dribbble.com/"
                className="footer__social-link"
                target="_blank"
              >
                <i class="bx bxl-instagram"></i>
              </a> */}
              <a
                href="https://github.com/andrewhsugithub"
                className="footer__social-link"
                target="_blank"
              >
                <i class="devicon-github-original"></i>
              </a>
              <a
                href="mailto: andrew1mail@gmail.com"
                className="footer__social-link"
                target="_blank"
              >
                <i class="bx bxl-gmail"></i>
              </a>
            </div>
            <span className="footer__copy">
              &#169; Andrew Hsu. All rights reserved.
            </span>
          </div>
        </footer>
      </Reveal>
    </div>
  );
};

export default Footer;
